export class RepairPriorityPayload {
    public contractorIdentifier?: string = ''
    public isEmergency?: boolean = false
    public isRecall?: boolean = false
    public repairType?: string = ''
    public isEMA?: string = ''
    public description?: string = ''
    public isVulnerable?: boolean = false
    public raisedDate?: string = ''
    public isAnaType?: boolean = false
    public isV14Upgradable?: boolean = false
    public channel?: string = ''
    public riskRating?: string = ''
    public type?: string = ''
    public assessmentType?: string = ''
    public tenureCode?: string = ''
    public workProgramme?: string = ''
    public premisesType?: string = ''
    public hasAdditionalNeeds?: boolean = false
    public IsSupportedResident?: boolean = false
}
export class RepairLocationPriorityPayload {
    public isEmergency?: boolean = false
    public isRecall?: boolean = false
    public repairType?: string = ''
    public isEMA?: string = ""
    public isVulnerable?: boolean = false
    public raisedDate?: string = ''
    public channel?: string = ''
    public riskRating?: string = ''
    public type?: string = ''
    public description?: string = ''
    public isAnaType?: boolean = false
    public isV14Upgradable?: boolean = false
    public tenureCode?: string = ''
    public workProgramme?: string = ''
    public premisesType?: string = ''
}
export class RepairPriorityResposne {
    public isWorkingHour: string = ''
    public isHoliday: boolean = false
    public repairPriority: string = ''
}

export class DmcAssessmentPriority {
    public riskRating: string = ''
    public totalScore: number = 0
    public vulnerabilityScore: number = 0
    public adjustedRiskRating: string = ''
    public vulnerabilityRiskRating: string = ''
}

export enum CasePriority {
    High = 'HIGH',
    Medium = 'MEDIUM',
    Low = 'LOW'
}

export enum RepairPriorityCode {
    Emergency = 'EME',
    NextAvailable = 'NA',
    DampAndMould = 'DM',
    DampAndMouldEmergency = 'DME'
}